import React from 'react';
import PropTypes from 'prop-types';
const defaultImage = '//s.qunarzz.com/package/touch/apphome/s/bg.jpg';
export default class LazyImage extends React.Component {
    static defaultProps = {
        options: {
            rootMargin: '0px',
            threshold: 0
        }
    };

    static contextTypes = {
        subscribe: PropTypes.func,
        unsubscribe: PropTypes.func,
        getParent: PropTypes.func
    };

    state = {
        useLazy: !!window.IntersectionObserver,
        showImg: false,
        defaultOptions: {
            rootMargin: '0px',
            threshold: 0
        }
    };

    componentDidMount() {
        const {defaultOptions = {}} = this.state;
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if(entry.isIntersecting) {
                    this.observer.unobserve(this.img);
                    this.setState({
                        showImg: true
                    });
                    this.observer = null;
                }
            });
        }, {root: this.context.getParent && this.context.getParent(), ...defaultOptions, ...this.props.options});
        this.observer.observe(this.img);
    }
    componentWillUnmount() {
        if(this.observer) {
            this.observer.unobserve(this.img);
            this.observer = null;
        }
    }

    render() {
        // eslint-disable-next-line
        const {options, ...extra} = this.props;
        return (
            <img {...extra} ref={ele => this.img = ele} src={!this.state.useLazy ? this.props.src : this.state.showImg ? this.props.src : defaultImage} alt="" />
        );
    }
}